<template>
  <div>
    Before firing, some electric propulsion systems need a warm-up
    phase, where electrical power is consumed even though no thrust is
    produced.
    <br />
    The user specifies the warm-up power
    <katex-element expression="P_\mathrm{wu}" /> expressed in W and the
    warm-up duration <katex-element expression="T_\mathrm{wu}" /> in
    minutes.
  </div>
</template>

<script>
export default {
  name: 'tooltipWarmUp'
}
</script>
